import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Button from '@chronos/components/Button';
import TrelloIcon from '@chronos/components/Icons/TrelloIcon';
import InstallPrompt from '../InstallPrompt';
import * as S from './styled';
import MainBanner from './styled/MainBannerSvg';

const AuthScreen = ({ onClick, showInstallPrompt }) => {
  const [isLoading, setLoading] = useState(false);

  return (
    <S.AuthScreen>
      {showInstallPrompt && <InstallPrompt />}
      <S.MainBanner>
        <MainBanner />
        <S.MainHeader>Chronos Time Tracker</S.MainHeader>
      </S.MainBanner>
      <S.AuthButton>
        <Button
          isLoading={isLoading}
          withIcon
          bigPadding
          onClick={(ev) => {
            setLoading(true);
            onClick(ev);
          }}
        >
          <TrelloIcon
            size="large"
            shouldPadding
          />
          Continue with Trello
        </Button>
      </S.AuthButton>
    </S.AuthScreen>
  );
};

AuthScreen.propTypes = {
  onClick: PropTypes.func.isRequired,
  showInstallPrompt: PropTypes.bool,
};
AuthScreen.defaultProps = {
  showInstallPrompt: false,
};

export default AuthScreen;
